import { render, staticRenderFns } from "./customerFlow.vue?vue&type=template&id=4f4f7e4d&scoped=true&"
import script from "./customerFlow.vue?vue&type=script&lang=js&"
export * from "./customerFlow.vue?vue&type=script&lang=js&"
import style0 from "./customerFlow.vue?vue&type=style&index=0&id=4f4f7e4d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4f7e4d",
  null
  
)

export default component.exports